import {
  Component,
  OnInit,
  ViewChild,
  Input,
  SimpleChanges,
  OnChanges
} from '@angular/core';

import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';

import { ClientEventService, MessageService } from '@radsource/ng-common-lib';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PatientInstance } from '../../objects/patient-instance';
import { InstanceService } from '../../services/instance.service';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { ToDicomNamePipe } from '../../pipes/to-dicom-name.pipe';
import { FromDicomNamePipe } from '../../pipes/from-dicom-name.pipe';


export const MY_FORMATS = MAT_MOMENT_DATE_FORMATS;

MY_FORMATS.display.dateInput = 'MM/DD/YYYY';

import { MatSnackBar } from '@angular/material';

const moment = _moment;

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'edit-patient',
  templateUrl: './edit-patient.component.html',
  styleUrls: ['./edit-patient.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class EditPatientComponent implements OnInit, OnChanges {

  @Input() patient: PatientInstance;
  organizationCode: string = "";
  errorText: string = null;
  deleting: Boolean = false;

  nameArr: Array<string> = new Array<string>();
  prefix: string = "";
  firstName: string = "";
  middleName: string = "";
  lastName: string = "";
  suffix: string = "";
  patientID: string = "";
  dateOfBirth: string = "";
  gender: string = "";

  nameRegex: string = "[a-zA-Z0-9., ]*"

  patientName = "";
  originPatientName = "";

  fromDCPipe = new FromDicomNamePipe();
  toDCPipe = new ToDicomNamePipe();

  showReset: Boolean = false;

  patientForm: FormGroup;

  popoverText: string = "";
  @ViewChild('t', { static: false }) public tooltip: NgbTooltip;

  constructor(
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private is: InstanceService,
    private ces: ClientEventService,
    private ms: MessageService
  ) { }

  ngOnInit() {
    this.initPatientForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initPatientForm();
  }

  clearPatientForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.patientForm.reset();
    this.patient.name = this.originPatientName;
    this.showReset = true;
  }

  revertPatientForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.patient.name = this.originPatientName;
    this.showReset = false;
    this.initPatientForm();
  }

  initPatientForm() {
    this.nameArr = [];
    if (this.patient) {
      if (this.patient.name) {
        if (this.patient.name.length > 0) {
          this.nameArr = this.fromDCPipe.transform(
            this.patient.name,
            false,
            true
          );
          this.lastName = (this.nameArr[0]) ? this.nameArr[0] : "";
          this.firstName = (this.nameArr[1]) ? this.nameArr[1] : "";
          this.middleName = (this.nameArr[2]) ? this.nameArr[2] : "";
          this.prefix = (this.nameArr[3]) ? this.nameArr[3] : "";
          this.suffix = (this.nameArr[4]) ? this.nameArr[4] : "";
        }

        this.patientID = (this.patient.id) ? this.patient.id : "";
        this.dateOfBirth = (this.patient.birth_date) ? this.patient.birth_date : "";
        this.gender = (this.patient.sex) ? this.patient.sex : "";
      }
      this.patientForm = this.fb.group({
        prefix: new FormControl((this.nameArr[3]) ? this.nameArr[3] : "",),
        firstName: new FormControl((this.nameArr[1]) ? this.nameArr[1] : "",),
        middleName: new FormControl((this.nameArr[2]) ? this.nameArr[2] : "",),
        lastName: new FormControl((this.nameArr[0]) ? this.nameArr[0] : "",),
        suffix: new FormControl((this.nameArr[4]) ? this.nameArr[4] : "",),
        id: new FormControl(this.patient.id, [Validators.required]),
        dateOfBirth: new FormControl(moment(this.dateOfBirth), [Validators.required]),
        gender: this.patient.sex
      });

      this.parseName();
      this.originPatientName = this.patient.name;
      this.patientForm.valueChanges.subscribe(val => {
        this.parseName();
      });

    }
  }

  revertPrefix() {
    this.patientForm.controls.prefix.setValue(this.prefix);
  }

  revertFirstName() {
    this.patientForm.controls.firstName.setValue(this.firstName);
  }

  revertMiddleName() {
    this.patientForm.controls.middleName.setValue(this.middleName);
  }

  revertLastName() {
    this.patientForm.controls.lastName.setValue(this.lastName);
  }

  revertSuffix() {
    this.patientForm.controls.suffix.setValue(this.suffix);
  }

  revertGender() {
    this.patientForm.controls.gender.setValue(this.gender);
  }

  revertPatientID() {
    this.patientForm.controls.id.setValue(this.patientID);
  }

  revertDateOfBirth() {
    this.patientForm.controls.dateOfBirth.setValue(this.dateOfBirth);
  }

  parseName() {
    this.nameArr[0] = this.patientForm.controls.lastName.value;
    this.nameArr[1] = this.patientForm.controls.firstName.value;
    this.nameArr[2] = this.patientForm.controls.middleName.value;
    this.nameArr[3] = this.patientForm.controls.prefix.value;
    this.nameArr[4] = this.patientForm.controls.suffix.value;
    this.patientName = this.toDCPipe.transform(this.nameArr);

  }

  applyForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.patient.birth_date = moment(this.patientForm.controls.dateOfBirth.value).format('YYYYMMDD').toString();
    this.patient.id = this.patientForm.controls.id.value;
    this.patient.name = this.patientName;
    this.patient.sex = this.patientForm.controls.gender.value;
    this.saveEdit();
  }

  saveEdit(): any {
    let patient = this.is.patients.find((p) => p.record_id == this.patient.record_id);
    if (patient) {
      patient.saving = true;
      patient.editing = false;
    }

    this.is.updatePatientAsOwner(this.patient)
      .then((res) => {
        this.is.patientEditing$.emit(false);
        if (patient) {
          patient.saving = false;
        }
        this.snackBar.open("Patient Updated", null, {
          duration: 1000,
        });
      }).catch((err) => {
        if (patient) {
          patient.editing = true;
          patient.saving = false;
        }
        this.snackBar.open("Update Failed", null, {
          duration: 1000,
        });
        this.errorText = err;
      });
  }

  closePopover() {
    this.popoverText = '';
    this.tooltip.close();
  }
}
